export interface LoginCredentials {
  login: string;
  password: string;
}

export interface AuthResponse {
  success: boolean;
  userId: string;
  role: string;
  guid: string;
  belongsStorage: string;
  cityId: string;
  lastPassUpd?: string | null;
  message?: string;
  versionMismatch?: boolean;
}

export interface FaceAuthResponse {
  success: boolean;
  user?: {
    id: number;
    username: string;
    role: string;
    guid?: string;
    deactivation?: number;
  };
  message?: string;
}

export type ServerStatus = 'connected' | 'error' | 'checking';

export interface AuthHookResult {
  loading: boolean;
  error: string | null;
  handleLogin: (credentials: LoginCredentials, rememberMe: boolean) => Promise<{ success: boolean; error?: string }>;
  clearError: () => void;
}

export interface FaceAuthHookResult {
  faceIdLoading: boolean;
  faceIdError: string | null;
  showFaceIdDialog: boolean;
  handleFaceIdLogin: () => void;
  handleFaceCapture: (blob: Blob) => Promise<void>;
  handleCloseFaceIdDialog: () => void;
}

export interface ServerStatusHookResult {
  serverStatus: ServerStatus;
  checkServerStatus: () => Promise<void>;
}

// Re-export password reset types
export * from './passwordResetTypes';